import axios from "axios";

const STATS_API = axios.create({
    baseURL: "https://mw.tvcom.uz/viewstats"
});

const statsMoviePush = async extraParams => {
    try {
        const { data } = await STATS_API.get(`/api/stat/video/push/`, {
            params: {
                ...extraParams,
                authkey: localStorage.getItem("token"),
                device: "browser",
                client_id: 1
            }
        });

        return data.data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

const statsTvPush = async extraParams => {
    try {
        const { data } = await STATS_API.get(`/api/stat/push/`, {
            params: {
                ...extraParams,
                authkey: localStorage.getItem("token"),
                device: "browser",
                client_id: 1
            }
        });

        return data.data;
    } catch (error) {
        return error;
    }
};

export default {
    statsMoviePush,
    statsTvPush
};
